import axios from "../plugins/parseAxios";

export class AdminApi {
  static createAdmin(userId, projectId) {
    return axios.post("functions/createAdmin", {
      userId,
      projectId
    });
  }
  static removeAdmin(id) {
    return axios.post("functions/removeAdmin", {
      id
    });
  }
  static getAdminByProject(projectId) {
    return axios.post("functions/getAdminByProject", {
      projectId
    });
  }
}